var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      [
        _c("ul", { staticClass: "nav" }, [
          _c("li", { class: [_vm.lang] }, [_vm._v(_vm._s(_vm.$t("Invoice")))]),
        ]),
      ],
      _c("a-spin", { attrs: { size: "large", spinning: _vm.loading } }, [
        _c(
          "div",
          { staticClass: "wrap-table" },
          [
            _c("a-table", {
              staticClass: "custom-scrollbar",
              attrs: {
                size: "middle",
                columns: _vm.columns,
                rowKey: (record, index) => index,
                "data-source": _vm.tableData,
                pagination: false,
                "row-class-name": (_record, index) =>
                  index % 2 !== 1 ? "table-bg" : null,
                customRow: (record) => {
                  return {
                    on: {
                      click: () => _vm.goDetail(record),
                    },
                  }
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "payType",
                  fn: function (text, record) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            record.duration_type == 2
                              ? _vm.$t("AnnualPayment")
                              : record.duration_type == 3
                              ? _vm.$t("MonthlyPayment")
                              : _vm.$t("InvoiceFree")
                          )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "action",
                  fn: function (text, record) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadPdf(record)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "download" } }),
                          _vm._v(" PDF"),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }